/**
 * Avatar with initials. Deterministic color (excluding red/yellow per design rules).
 * Falls back to user.avatar_color if provided.
 */
export function initials(name) {
    if (!name) return "??";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

const PALETTE = ["#0F4C81", "#1B7CB8", "#38BDF8", "#0EA5E9",
                 "#16A34A", "#059669", "#7C3AED", "#9333EA",
                 "#0891B2", "#0D9488", "#475569", "#334155"];

export function colorFor(name) {
    if (!name) return "#475569";
    let sum = 0;
    for (let i = 0; i < name.length; i++) sum += name.charCodeAt(i);
    return PALETTE[sum % PALETTE.length];
}

export function Avatar({ name, color, size = 32, className = "", ...rest }) {
    const bg = color || colorFor(name);
    const fs = Math.max(10, Math.round(size * 0.38));
    return (
        <span
            className={`vh-avatar ${className}`}
            style={{ width: size, height: size, fontSize: fs, background: bg }}
            title={name}
            {...rest}
        >
            {initials(name)}
        </span>
    );
}
